<template>
  <div class="container-circlehValue" id="container-circlehValue">
    <canvas
      :id="canvasId"
      :style="{ width: width + 'px', height: height + 'px' }"
    ></canvas>
    <span
      class="prompt"
      ref="prompt"
      :style="{
        left: pX + 'px',
        top: pY + 'px',
        width: pWidth + 'px',
        height: pHeight + 'px',
      }"
      v-show="isPrompt"
      >用户改善全部可控风险因素后，可达到的最高健康值</span
    >
    <span
      class="prompt"
      ref="prompt1"
      :style="{
        left: pTargetX + 'px',
        top: pTargetY + 'px',
        width: pTargetWidth + 'px',
        height: pTargetHeight + 'px',
      }"
      v-show="isTargetPrompt"
      >用户当前健康管理完成后，可达到的最高健康值</span
    >
  </div>
</template>

<script>
export default {
  name: "circlehValue",
  props: {
    canvasId: {
      type: String,
      default: "canvas-circlehValue",
    },
    progress: {
      type: Number,
      default: 0,
    },
    pefectValue: {
      type: Number,
      default: 0,
    },
    targetValue: {
      type: Number,
      default: 0,
    },
    colorValue: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      circleLoading1: null,

      process: 0,
      width: 0,
      height: 0,
      // 理想值
      img1x: -1,
      img1y: -1,
      img2x: -1,
      img2y: -1,
      isPrompt: false,
      pX: 0,
      pY: 0,
      pWidth: 140,
      pHeight: 40,
      // 目标值
      imgTarget1x: -1,
      imgTarget1y: -1,
      imgTarget2x: -1,
      imgTarget2y: -1,
      isTargetPrompt: false,
      pTargetX: 0,
      pTargetY: 0,
      pTargetWidth: 140,
      pTargetHeight: 40,

      radiusLine: 0,
      textPadding: 0,

      processPefect: 0,
      processTarget: 0,
    };
  },
  created() {
    this.$nextTick(() => {
      this.load();
    });
  },
  watch: {
    progress(val) {
      this.load();
    },
  },
  methods: {
    load() {
      let containerProgress = document.getElementById("container-circlehValue");
      let container = containerProgress.getBoundingClientRect();
      this.width = container.width;
      this.height = container.height;

      let canvas = document.getElementById(this.canvasId);
      let context = canvas.getContext("2d");

      let dpr = window.devicePixelRatio; // 假设dpr为2
      // dpr = 1.5;
      // let dpr = 3; // 假设dpr为2
      // 获取css的宽高
      // let { width: cssWidth, height: cssHeight } = canvas.getBoundingClientRect();
      // 根据dpr，扩大canvas画布的像素，使1个canvas像素和1个物理像素相等
      canvas.width = dpr * this.width;
      canvas.height = dpr * this.height;

      let radiusLine = 20 * dpr;
      this.radiusLine = radiusLine;

      let textPadding = 60 * dpr;
      this.textPadding = textPadding;

      let that = this;
      //鼠标移动
      canvas.addEventListener(
        "mousemove",
        function (e) {
          that.moveEvent(e.layerX * dpr, e.layerY * dpr);
        },
        false
      );

      this.process = 0;
      this.processTarget = 0;
      this.processPefect = 0;

      // this.pefectValue = 750;
      // this.targetValue = 750;

      this.circleLoading1 = setInterval(() => {
        if (this.processPefect >= this.pefectValue) {
          this.processPefect = this.pefectValue;
          clearInterval(this.circleLoading1);
          this.drawPefect(context, canvas, dpr);
        } else {
          this.drawCircle(context, canvas, dpr);
          // this.drawCircle(context, canvas, dpr);
        }

        if (this.process < this.progress) {
          if (this.progress - this.process >= 10) {
            this.process += 9;
          } else {
            this.process += 1.0;
          }
        }

        if (this.processTarget < this.targetValue) {
          if (this.targetValue - this.processTarget >= 10) {
            this.processTarget += 9;
          } else {
            this.processTarget += 1.0;
          }
        }

        if (this.processPefect < this.pefectValue) {
          if (this.pefectValue - this.processPefect >= 10) {
            this.processPefect += 9;
          } else {
            this.processPefect += 1.0;
          }
        }
      }, 10);

      // this.process = that.progress;
      // that.drawCircle(context, canvas, dpr);
    },
    moveEvent(mX, mY, context, canvas, dpr) {
      this.isPrompt = false;
      if (
        mX >= this.img1x &&
        mX <= this.img2x &&
        mY >= this.img1y &&
        mY <= this.img2y
      ) {
        this.isPrompt = true;
      }
      this.isTargetPrompt = false;
      if (
        mX >= this.imgTarget1x &&
        mX <= this.imgTarget2x &&
        mY >= this.imgTarget1y &&
        mY <= this.imgTarget2y
      ) {
        this.isTargetPrompt = true;
      }
    },
    drawCircle(context, canvas, dpr) {
      // if (this.pefectValue) {
      // context.strokeStyle = '#0077F9';

      context.clearRect(0, 0, canvas.width, canvas.height);

      context.save();

      let center_x = canvas.width / 2;
      let center_y = canvas.height / 2;

      context.translate(center_x, center_y);

      context.lineWidth = this.radiusLine;

      let radius =
        Math.min(canvas.width, canvas.height) / 2 -
        this.textPadding / 2 -
        this.radiusLine;

      context.strokeStyle = "#EBECF2";
      // context.strokeStyle = "#ff6600";
      context.beginPath();
      context.arc(
        0,
        0,
        radius,
        -Math.PI / 2,
        -Math.PI / 2 + (this.processPefect / 1000) * 2 * Math.PI + 10
      );
      // context.closePath()
      context.stroke();

      if (this.processTarget > 0) {
        context.strokeStyle = "#75CDFF";
        context.beginPath();
        context.arc(
          0,
          0,
          radius,
          -Math.PI / 2,
          -Math.PI / 2 + (this.processTarget / 1000) * 2 * Math.PI
        );
        // context.closePath()
        context.stroke();
      }

      context.strokeStyle = this.colorValue;
      context.beginPath();
      context.arc(
        0,
        0,
        radius,
        -Math.PI / 2,
        -Math.PI / 2 + (this.process / 1000) * 2 * Math.PI
      );
      // context.closePath()
      context.stroke();

      let font = 31 * dpr;
      context.font = `${font}px PingFangSC-Semibold`;
      context.textBaseline = "middle";
      context.textAlign = "center";
      context.fillStyle = "#333";
      context.fillText(this.progress, 0, 0);

      context.strokeStyle = "#0077F9";
      context.lineWidth = 1 * dpr;
      context.beginPath();

      let length1 = 3 * dpr;
      let angle = (this.processPefect / 1000) * (Math.PI * 2);
      let x1 = Math.floor(
        Math.cos(angle - Math.PI / 2) * (radius + this.radiusLine / 2 + length1)
      );
      let y1 = Math.floor(
        Math.sin(angle - Math.PI / 2) * (radius + this.radiusLine / 2 + length1)
      );
      let x2 = Math.floor(
        Math.cos(angle - Math.PI / 2) * (radius - this.radiusLine / 2 - length1)
      );
      let y2 = Math.floor(
        Math.sin(angle - Math.PI / 2) * (radius - this.radiusLine / 2 - length1)
      );

      context.moveTo(x1 - 0.5 * dpr, y1);
      context.lineTo(x2 - 0.5 * dpr, y2);
      // context.moveTo(0,0);
      // context.lineTo(30,30);
      context.closePath(); //结束路径
      context.stroke();

      context.restore();
      // }
    },
    drawPefect(context, canvas, dpr) {
      let imgPadding = 8 * dpr;
      let textPadding = 4 * dpr;
      let length1 = 3 * dpr;

      let radius =
        Math.min(canvas.width, canvas.height) / 2 -
        this.textPadding / 2 -
        this.radiusLine;

      let imgWidth = 12 * dpr;
      let imgHeight = 12 * dpr;

      let that = this;

      let imgRadius = radius + this.radiusLine / 2 + length1 + imgPadding;
      let minDistance = 16 * dpr;

      let minDegree = (minDistance / 2 / imgRadius) * 2;

      let angleTarget = (this.processTarget / 1000) * (Math.PI * 2);

      let anglePefect = (this.processPefect / 1000) * (Math.PI * 2);
      // console.log('anglePefect = ', anglePefect);

      if (this.processTarget > 0) {
        let currentDegree = anglePefect - angleTarget;
        // console.log('currentDegree = ', currentDegree);

        if (currentDegree < minDegree) {
          let dif = (minDegree - currentDegree) / 2;
          // console.log('dif = ', dif);
          angleTarget -= dif;
          anglePefect += dif;
        }
      }

      // console.log('angleTarget = ', angleTarget);
      // console.log('anglePefect = ', anglePefect);

      let x1T = Math.floor(Math.cos(angleTarget - Math.PI / 2) * imgRadius);
      let y1T = Math.floor(Math.sin(angleTarget - Math.PI / 2) * imgRadius);

      let x1 = Math.floor(Math.cos(anglePefect - Math.PI / 2) * imgRadius);
      let y1 = Math.floor(Math.sin(anglePefect - Math.PI / 2) * imgRadius);

      if (this.processTarget > 0) {
        if (Math.abs(y1 - y1T) < minDistance) {
          let dif = minDistance - Math.abs(y1 - y1T);
          // console.log('dif111 = ', dif);
          // console.log('y1 y1T= ', y1,y1T);
          if (x1 > 0) {
            if (y1 < 0) {
              y1T -= dif;
            } else {
              y1 += dif;
            }
          } else {
            if (y1 < 0) {
              y1 -= dif;
            } else {
              y1T += dif;
            }
          }
        }
      }

      // if (this.processTarget > 0  && this.processPefect > 0) {
      //     let a = x1T - x1;
      //     let b = y1T - y1;

      //     let distance = Math.sqrt(a*a+b*b);
      //     console.log('distance = ', distance);

      //     if (distance < minDistance) {
      //         let moveDistance = (minDistance - distance)/2;
      //         x1T
      //     }
      // }

      if (this.processTarget > 0) {
        // console.log('canvas.width',canvas.width);
        this.pTargetX = (canvas.width / 2 + x1T) / dpr;
        this.pTargetY = (canvas.height / 2 + y1T) / dpr;
        this.pTargetWidth = this.pTargetWidth;
        this.pTargetHeight = this.pTargetHeight;

        if (this.pTargetX + this.pTargetWidth > this.width) {
          this.pTargetX = this.pTargetX - this.pTargetWidth;
        }
        if (this.pTargetY + this.pTargetHeight > this.height) {
          this.pTargetY = this.pTargetY - this.pTargetHeight;
        }

        let imageTarget = new Image();
        imageTarget.src = require("@/assets/images/h_healthValueAsk.png");
        imageTarget.onload = function () {
          // console.log(image);

          let font1 = 12 * dpr;
          let perfectString = "目标值" + that.targetValue;
          context.font = `${font1}px PingFangSC-Regular`;
          context.textBaseline = "top";
          // context.textAlign = x1 < 0 ?"right":x1 > 0?'left':'center';
          context.fillStyle = "#333";

          if (x1T < 0) {
            // console.log('right');

            that.imgTarget1x = canvas.width / 2 + x1T - imgWidth / 2;
            that.imgTarget1y = canvas.height / 2 + y1T - imgHeight / 2;

            that.imgTarget2x = that.imgTarget1x + imgWidth;
            that.imgTarget2y = that.imgTarget1y + imgHeight;

            context.drawImage(
              imageTarget,
              that.imgTarget1x,
              that.imgTarget1y,
              imgWidth,
              imgHeight
            );

            context.textAlign = "right";
            context.fillText(
              perfectString,
              that.imgTarget1x - textPadding,
              that.imgTarget1y
            );
          } else if (x1T == 0) {
            // console.log('center');
            // context.textAlign = 'center';
            // context.fillText(perfectString, x1, y1 + font1/2);

            that.imgTarget1x = canvas.width / 2 + x1T - imgWidth / 2;
            if (that.yTarget1 > 0) {
              that.imgTarget1y = canvas.height / 2 + y1T + imgHeight / 2;
            } else {
              that.imgTarget1y = canvas.height / 2 + y1T - imgHeight / 2;
            }

            that.imgTarget2x = that.imgTarget1x + imgWidth;
            that.imgTarget2y = that.imgTarget1y + imgHeight;

            context.drawImage(
              imageTarget,
              that.imgTarget1x,
              that.imgTarget1y,
              imgWidth,
              imgHeight
            );

            context.textAlign = "right";
            context.fillText(
              perfectString,
              that.imgTarget1x - textPadding,
              that.imgTarget1y
            );
          } else {
            // console.log('left');
            // console.log('x1,y1,imgWidth,imgHeight',x1,y1,imgWidth,imgHeight);

            that.imgTarget1x = canvas.width / 2 + x1T - imgWidth / 2;
            that.imgTarget1y = canvas.height / 2 + y1T - imgHeight / 2;

            that.imgTarget2x = that.imgTarget1x + imgWidth;
            that.imgTarget2y = that.imgTarget1y + imgHeight;

            context.drawImage(
              imageTarget,
              that.imgTarget1x,
              that.imgTarget1y,
              imgWidth,
              imgHeight
            );

            context.textAlign = "left";
            context.fillText(
              perfectString,
              that.imgTarget1x + imgWidth + textPadding,
              that.imgTarget1y
            );
          }
        };
      }

      // console.log('x1T,y1T',x1T,y1T);
      // console.log('pTargetX,pTargetY',this.pTargetX,this.pTargetY);

      if (this.processPefect > 0) {
        this.pX = (canvas.width / 2 + x1) / dpr;
        this.pY = (canvas.height / 2 + y1) / dpr;
        this.pWidth = this.pWidth;
        this.pHeight = this.pHeight;
        if (this.pX + this.pWidth > this.width) {
          this.pX = this.pX - this.pWidth;
        }
        if (this.pY + this.pHeight > this.height) {
          this.pY = this.pY - this.pHeight;
        }

        // console.log('x1,y1',x1,y1);

        let imagePefect = new Image();
        imagePefect.src = require("@/assets/images/h_healthValueAsk.png");

        imagePefect.onload = function () {
          // console.log(image);

          let font1 = 12 * dpr;
          let perfectString = "理想值" + that.pefectValue;
          context.font = `${font1}px PingFangSC-Regular`;
          context.textBaseline = "top";
          // context.textAlign = x1 < 0 ?"right":x1 > 0?'left':'center';
          context.fillStyle = "#333";
          // let measureText = context.measureText(perfectString);

          if (x1 < 0) {
            // console.log('right');

            that.img1x = canvas.width / 2 + x1 - imgWidth / 2;
            that.img1y = canvas.height / 2 + y1 - imgHeight / 2;

            that.img2x = that.img1x + imgWidth;
            that.img2y = that.img1y + imgHeight;

            context.drawImage(
              imagePefect,
              that.img1x,
              that.img1y,
              imgWidth,
              imgHeight
            );

            context.textAlign = "right";
            context.fillText(
              perfectString,
              that.img1x - textPadding,
              that.img1y
            );
          } else if (x1 == 0) {
            // console.log('center');
            // context.textAlign = 'center';
            // context.fillText(perfectString, x1, y1 + font1/2);

            that.img1x = canvas.width / 2 + x1 - imgWidth / 2;
            if (that.y1 > 0) {
              that.img1y = canvas.height / 2 + y1 + imgHeight / 2;
            } else {
              that.img1y = canvas.height / 2 + y1 - imgHeight / 2;
            }

            that.img2x = that.img1x + imgWidth;
            that.img2y = that.img1y + imgHeight;

            context.drawImage(
              imagePefect,
              that.img1x,
              that.img1y,
              imgWidth,
              imgHeight
            );

            context.textAlign = "right";
            context.fillText(
              perfectString,
              that.img1x - textPadding,
              that.img1y
            );
          } else {
            // console.log('left');
            // console.log('x1,y1,imgWidth,imgHeight',x1,y1,imgWidth,imgHeight);

            that.img1x = canvas.width / 2 + x1 - imgWidth / 2;
            that.img1y = canvas.height / 2 + y1 - imgHeight / 2;

            that.img2x = that.img1x + imgWidth;
            that.img2y = that.img1y + imgHeight;

            context.drawImage(
              imagePefect,
              that.img1x,
              that.img1y,
              imgWidth,
              imgHeight
            );

            context.textAlign = "left";
            context.fillText(
              perfectString,
              that.img1x + imgWidth + textPadding,
              that.img1y
            );
          }
        };
      }

      // console.log('y1T,y1',y1T,y1);
      // let minPadding = 16*dpr;
      // let spacedPadding = Math.abs(y1 - y1T);
      // console.log('spacedPadding',spacedPadding);
      // if (spacedPadding < minPadding) {
      //     // y1T += minPadding/2 - Math.abs(spacedPadding);
      //     // console.log('x1,y1',x1,y1);
      //     if (x1 > 0) {
      //         y1 += (minPadding - spacedPadding)/2;
      //     } else {
      //         y1 -= (minPadding - spacedPadding)/2;
      //     }
      //     // console.log('y1T,y1',y1T,y1);
      //     // let minPadding = 16*dpr;
      //     // let spacedPadding = Math.abs(y1 - y1T);
      //     // console.log('spacedPadding',spacedPadding);
      //     // if (spacedPadding < minPadding) {
      //     //     // y1T += minPadding/2 - Math.abs(spacedPadding);
      //     //     // console.log('x1,y1',x1,y1);
      //     //     if (x1 > 0) {
      //     //         y1 += (minPadding - spacedPadding)/2;
      //     //     } else {
      //     //         y1 -= (minPadding - spacedPadding)/2;
      //     //     }
      //         // if (y1 >= 0) {
      //         //     x1T += minPadding/2;
      //         // } else {
      //         //     x1T -= minPadding/2;
      //         // }
      //     //     // if (y1 >= 0) {
      //     //     //     x1T += minPadding/2;
      //     //     // } else {
      //     //     //     x1T -= minPadding/2;
      //     //     // }

      //     //     if (x1T > 0) {
      //     //         y1T -= (minPadding - spacedPadding)/2;
      //     //     } else {
      //     //         y1T += (minPadding - spacedPadding)/2;
      //     //     }

      // }
    },
    fillRoundRect(cxt, x, y, width, height, radius, /*optional*/ fillColor) {
      //圆的直径必然要小于矩形的宽高
      if (2 * radius > width || 2 * radius > height) {
        return false;
      }

      cxt.save();
      cxt.translate(x, y);
      //绘制圆角矩形的各个边
      this.drawRoundRectPath(cxt, width, height, radius);
      cxt.fillStyle = fillColor || "#000"; //若是给定了值就用给定的值否则给予默认值
      cxt.fill();
      cxt.restore();
    },
    drawRoundRectPath(cxt, width, height, radius) {
      cxt.beginPath(0);
      //从右下角顺时针绘制，弧度从0到1/2PI
      cxt.arc(width - radius, height - radius, radius, 0, Math.PI / 2);

      //矩形下边线
      cxt.lineTo(radius, height);

      //左下角圆弧，弧度从1/2PI到PI
      cxt.arc(radius, height - radius, radius, Math.PI / 2, Math.PI);

      //矩形左边线
      cxt.lineTo(0, radius);

      //左上角圆弧，弧度从PI到3/2PI
      cxt.arc(radius, radius, radius, Math.PI, (Math.PI * 3) / 2);

      //上边线
      cxt.lineTo(width - radius, 0);

      //右上角圆弧
      cxt.arc(width - radius, radius, radius, (Math.PI * 3) / 2, Math.PI * 2);

      //右边线
      cxt.lineTo(width, height - radius);
      cxt.closePath();
    },
    textHeight(ctx, text, maxWidth, lineHeight) {
      let finalHeight = lineHeight;
      let arrText = text.split("");
      let line = "";
      for (let n = 0; n < arrText.length; n++) {
        let testLine = line + arrText[n];
        let metrics = ctx.measureText(testLine);
        let testWidth = metrics.width;
        if (testWidth > maxWidth && n > 0) {
          line = arrText[n];
          finalHeight += lineHeight;
        } else {
          line = testLine;
        }
      }
      return finalHeight;
    },
    drawText(ctx, text, x, y, maxWidth, lineHeight) {
      let finalHeight = lineHeight;
      let canvas = ctx.canvas;
      let arrText = text.split("");
      let line = "";
      for (let n = 0; n < arrText.length; n++) {
        let testLine = line + arrText[n];
        let metrics = ctx.measureText(testLine);
        let testWidth = metrics.width;
        if (testWidth > maxWidth && n > 0) {
          ctx.fillText(line, x, y);
          line = arrText[n];
          y += lineHeight;
          finalHeight += lineHeight;
        } else {
          line = testLine;
        }
      }
      ctx.fillText(line, x, y);
      return finalHeight;
    },
  },
};
</script>

<style scoped>
.container-circlehValue {
  box-sizing: border-box;
  /* background-color: burlywood; */
  position: relative;
}

.prompt {
  color: #fff;
  font-size: 12px;
  border-radius: 4px;
  display: inline-block;
  box-sizing: border-box;
  text-align: center;
  padding: 3px 4px;
  /* width: 140px;
																  height: 40px; */
  background-color: rgba(0, 0, 0, 0.5);
  position: absolute;
  /* left: 10px;
																  top: 10px; */
}
</style>
